import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-dialog__body" }
const _hoisted_2 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_3 = { class: "settings-section" }
const _hoisted_4 = { class: "section-small-title" }
const _hoisted_5 = { class: "settings-form-grid" }
const _hoisted_6 = { class: "ui-field" }
const _hoisted_7 = { class: "support-types-field" }
const _hoisted_8 = { class: "support-type-options" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "settings-checks" }
const _hoisted_11 = { class: "check-label" }
const _hoisted_12 = { class: "check-label" }
const _hoisted_13 = { class: "check-label" }
const _hoisted_14 = { class: "ui-field" }
const _hoisted_15 = { class: "settings-section" }
const _hoisted_16 = { class: "section-small-title" }
const _hoisted_17 = { class: "settings-module-filters" }
const _hoisted_18 = { class: "ui-field" }
const _hoisted_19 = {
  class: "segmented-control",
  role: "group",
  "aria-label": "Тип модулей"
}
const _hoisted_20 = { class: "check-label" }
const _hoisted_21 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_22 = { class: "font-medium" }
const _hoisted_23 = { class: "module-group-actions" }
const _hoisted_24 = { class: "module-list" }
const _hoisted_25 = { class: "module-item__header" }
const _hoisted_26 = { class: "check-label module-check" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "module-item__name" }
const _hoisted_29 = { class: "module-price num" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  class: "module-item__details"
}
const _hoisted_32 = {
  key: 0,
  class: "module-edit-grid"
}
const _hoisted_33 = { class: "ui-field" }
const _hoisted_34 = { class: "ui-field" }
const _hoisted_35 = { class: "ui-field" }
const _hoisted_36 = ["for"]
const _hoisted_37 = { class: "check-label" }
const _hoisted_38 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_39 = { class: "ui-field" }

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';
import { Spinner } from '@/components/ui/spinner';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetFooter,
} from '@/components/ui/sheet';
import { ShieldCheck, Puzzle, NotebookPen } from '@lucide/vue';

import { ref, computed, watch } from 'vue';
import axios from 'axios';

type PayFilter = 'all' | 'paid' | 'free';

interface ModuleState {
  active: boolean;
  license_expires: string | null;
  isUnlimited: boolean;
  notes: string;
  price: string;
  acquired_at: string | null;
}

interface SupportForm {
  support_till: string | null;
  support_type_ids: number[];
  support_suspended: boolean;
  support_24on7: boolean;
  support_weekend: boolean;
  support_notes: string;
}

interface ModuleSectionVm {
  key: string;
  title: string;
  modules: CatalogModule[];
}

interface Props {
  modelValue: boolean;
  propertyId: number;
  productId: number;
  productName: string;
  currentModules: PropertyModule[];
  supportInfo?: ProductSupporter | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyProductSettingsDialog',
  props: {
    modelValue: { type: Boolean },
    propertyId: {},
    productId: {},
    productName: {},
    currentModules: {},
    supportInfo: {}
  },
  emits: ['update:modelValue', 'saved'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const drawer = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const loading = ref(false);
const saving = ref(false);

const supportTypes = ref<SupportTypeDict[]>([]);
const supportForm = ref<SupportForm>({
  support_till: null,
  support_type_ids: [],
  support_suspended: false,
  support_24on7: false,
  support_weekend: false,
  support_notes: '',
});

const availableModules = ref<CatalogModule[]>([]);
const moduleSearch = ref('');
const payFilter = ref<PayFilter>('all');
const connectedOnly = ref(false);
const moduleStates = ref<Record<number, ModuleState>>({});
const openNotesIds = ref(new Set<number>());

function isNotesOpen(moduleId: number): boolean {
  return openNotesIds.value.has(moduleId);
}

function openNotes(moduleId: number) {
  openNotesIds.value = new Set([...openNotesIds.value, moduleId]);
}

function closeNotes(moduleId: number) {
  const next = new Set(openNotesIds.value);
  next.delete(moduleId);
  openNotesIds.value = next;
}

function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (Number.isNaN(n)) return '';
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(n);
}

const assignableRows = computed(() => {
  const rows: { module: CatalogModule; group: { id: number; name: string } | null }[] = [];
  for (const root of availableModules.value) {
    const children = root.children?.length ? root.children : [];
    if (children.length) {
      for (const child of children) {
        rows.push({ module: child, group: { id: root.id, name: root.name } });
      }
    } else {
      rows.push({ module: root, group: null });
    }
  }
  return rows;
});

const filteredRows = computed(() => {
  return assignableRows.value.filter((row) => {
    const m = row.module;
    if (payFilter.value === 'paid' && !m.is_paid) return false;
    if (payFilter.value === 'free' && m.is_paid) return false;
    if (connectedOnly.value && !moduleStates.value[m.id]?.active) return false;
    if (moduleSearch.value.trim()) {
      const q = moduleSearch.value.toLowerCase().trim();
      const inName = m.name.toLowerCase().includes(q);
      const inGroup = row.group?.name.toLowerCase().includes(q);
      if (!inName && !inGroup) return false;
    }
    return true;
  });
});

const moduleSections = computed((): ModuleSectionVm[] => {
  const map = new Map<string, { title: string; modules: CatalogModule[] }>();
  for (const row of filteredRows.value) {
    const key = row.group ? `g-${row.group.id}` : 'standalone';
    const title = row.group ? row.group.name : 'Без группы';
    if (!map.has(key)) {
      map.set(key, { title, modules: [] });
    }
    map.get(key)?.modules.push(row.module);
  }
  const entries = [...map.entries()].map(([key, v]) => ({
    key,
    title: v.title,
    modules: [...v.modules].sort((a, b) => a.name.localeCompare(b.name, 'ru')),
  }));
  entries.sort((a, b) => {
    if (a.key === 'standalone') return 1;
    if (b.key === 'standalone') return -1;
    return a.title.localeCompare(b.title, 'ru');
  });
  return entries;
});

function getModuleState(moduleId: number): ModuleState {
  if (!moduleStates.value[moduleId]) {
    moduleStates.value[moduleId] = {
      active: false,
      license_expires: null,
      isUnlimited: true,
      notes: '',
      price: '',
      acquired_at: null,
    };
  }
  return moduleStates.value[moduleId];
}

function findCatalogModule(moduleId: number): CatalogModule | undefined {
  for (const row of assignableRows.value) {
    if (row.module.id === moduleId) return row.module;
  }
  return undefined;
}

function updateModuleActive(moduleId: number, active: boolean, catalogMod?: CatalogModule) {
  const state = getModuleState(moduleId);
  state.active = active;
  const mod = catalogMod ?? findCatalogModule(moduleId);
  if (active && mod?.is_paid && (!state.price || state.price === '') && mod.default_price) {
    state.price = String(mod.default_price);
  }
}

function updateModuleField(
  moduleId: number,
  field: 'license_expires' | 'notes' | 'price' | 'acquired_at',
  value: string | null
) {
  const state = getModuleState(moduleId);
  if (field === 'price') {
    state.price = value ?? '';
    return;
  }
  if (field === 'acquired_at') {
    state.acquired_at = value || null;
    return;
  }
  if (field === 'license_expires') {
    state.license_expires = value;
    return;
  }
  state.notes = value ?? '';
}

function updateUnlimited(moduleId: number, isUnlimited: boolean) {
  const state = getModuleState(moduleId);
  state.isUnlimited = isUnlimited;
  if (isUnlimited) {
    state.license_expires = null;
  }
}

function enableGroup(modules: CatalogModule[]) {
  for (const mod of modules) {
    updateModuleActive(mod.id, true, mod);
  }
}

function disableGroup(modules: CatalogModule[]) {
  for (const mod of modules) {
    getModuleState(mod.id).active = false;
  }
}

function initModuleStates() {
  moduleStates.value = {};
  openNotesIds.value = new Set();
  for (const row of assignableRows.value) {
    const module = row.module;
    const current = props.currentModules.find((m) => m.module_id === module.id);
    const defPrice = module.default_price != null ? String(module.default_price) : '';
    moduleStates.value[module.id] = {
      active: !!current,
      license_expires: current?.license_expires || null,
      isUnlimited: !current?.license_expires,
      notes: current?.notes || '',
      price:
        current?.price != null && String(current.price) !== ''
          ? String(current.price)
          : module.is_paid && defPrice
            ? defPrice
            : '',
      acquired_at: current?.acquired_at || null,
    };
  }
}

function initSupportForm() {
  const info = props.supportInfo;
  supportForm.value = {
    support_till: info?.support_till || null,
    support_type_ids: info?.support_type_ids ?? [],
    support_suspended: info?.support_suspended ?? false,
    support_24on7: info?.support_24on7 ?? false,
    support_weekend: info?.support_weekend ?? false,
    support_notes: info?.support_notes ?? '',
  };
}

async function loadData() {
  if (!props.productId) return;

  loading.value = true;
  try {
    const modulesResp = await axios.get(`/api/products/${props.productId}/`);
    const data = modulesResp.data as { modules?: CatalogModule[] };
    const roots = data.modules ?? [];
    availableModules.value = roots.map((r) => ({
      ...r,
      children: r.children ?? [],
    }));

    initModuleStates();
    initSupportForm();
  } catch (error) {
    console.error('Failed to load modules:', error);
  }

  try {
    const typesResp = await axios.get('/api/support-types/');
    supportTypes.value = typesResp.data.results ?? typesResp.data;
  } catch (error) {
    console.error('Failed to load support types:', error);
  }

  loading.value = false;
}

async function save() {
  saving.value = true;
  try {
    const invalidModules = Object.entries(moduleStates.value).filter(([moduleId, state]) => {
      if (!state.active) return false;
      const module = findCatalogModule(parseInt(moduleId, 10));
      return Boolean(module?.is_paid) && !state.isUnlimited && !state.license_expires;
    });

    if (invalidModules.length > 0) {
      alert('Укажите дату окончания лицензии для выбранных модулей или отметьте "Бессрочно"');
      saving.value = false;
      return;
    }

    const modulesToSave = Object.entries(moduleStates.value)
      .filter(([_, state]) => state.active)
      .map(([moduleId, state]) => {
        const parsedId = parseInt(moduleId, 10);
        const module = findCatalogModule(parsedId);
        const isPaid = Boolean(module?.is_paid);

        return {
          module_id: parsedId,
          license_expires: isPaid ? (state.isUnlimited ? null : state.license_expires) : null,
          notes: state.notes,
          price: isPaid ? (state.price === '' ? null : state.price) : null,
          acquired_at: isPaid ? state.acquired_at || null : null,
        };
      });

    await Promise.all([
      axios.post(`/api/properties/${props.propertyId}/update-support-info/`, {
        product_id: props.productId,
        ...supportForm.value,
      }),
      axios.post(`/api/properties/${props.propertyId}/update-product-modules/`, {
        product_id: props.productId,
        modules: modulesToSave,
      }),
    ]);

    emit('saved');
    drawer.value = false;
  } catch (error) {
    console.error('Failed to save:', error);
  } finally {
    saving.value = false;
  }
}

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      loadData();
    }
  }
);

const paymentFilters: { value: PayFilter; label: string }[] = [
  { value: 'all', label: 'Все' },
  { value: 'paid', label: 'Платные' },
  { value: 'free', label: 'Бесплатные' },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sheet), {
    open: drawer.value,
    "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((drawer).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SheetContent), {
        class: "settings-dialog",
        side: "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SheetHeader), { class: "settings-dialog__header" }, {
            default: _withCtx(() => [
              _createVNode(_unref(SheetTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Настройки: " + _toDisplayString(__props.productName), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(SheetDescription), null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Поддержка и модули продукта", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(Spinner)),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "Загрузка настроек…", -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("section", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, [
                      _createVNode(_unref(ShieldCheck), { size: 17 }),
                      _cache[12] || (_cache[12] = _createTextVNode(" Поддержка ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("label", _hoisted_6, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ui-label" }, "Срок поддержки", -1)),
                        _createVNode(_unref(Input), {
                          modelValue: supportForm.value.support_till,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((supportForm.value.support_till) = $event)),
                          type: "date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("fieldset", _hoisted_7, [
                        _cache[14] || (_cache[14] = _createElementVNode("legend", { class: "ui-label" }, "Тип поддержки", -1)),
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportTypes.value, (type) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: type.id,
                              class: "check-label"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((supportForm.value.support_type_ids) = $event)),
                                class: "native-checkbox",
                                type: "checkbox",
                                value: type.id
                              }, null, 8, _hoisted_9), [
                                [_vModelCheckbox, supportForm.value.support_type_ids]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(type.name), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, [
                        _createVNode(_unref(Checkbox), {
                          modelValue: supportForm.value.support_suspended,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((supportForm.value.support_suspended) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Поддержка приостановлена", -1))
                      ]),
                      _createElementVNode("label", _hoisted_12, [
                        _createVNode(_unref(Checkbox), {
                          modelValue: supportForm.value.support_24on7,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((supportForm.value.support_24on7) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Поддержка 24/7", -1))
                      ]),
                      _createElementVNode("label", _hoisted_13, [
                        _createVNode(_unref(Checkbox), {
                          modelValue: supportForm.value.support_weekend,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((supportForm.value.support_weekend) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "Поддержка в выходные", -1))
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_14, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "ui-label" }, "Заметки", -1)),
                      _createVNode(_unref(Textarea), {
                        modelValue: supportForm.value.support_notes,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((supportForm.value.support_notes) = $event)),
                        rows: "2"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_15, [
                    _createElementVNode("h3", _hoisted_16, [
                      _createVNode(_unref(Puzzle), { size: 17 }),
                      _cache[19] || (_cache[19] = _createTextVNode(" Модули ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "ui-label" }, "Поиск модуля", -1)),
                        _createVNode(_unref(Input), {
                          modelValue: moduleSearch.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((moduleSearch).value = $event)),
                          type: "search",
                          placeholder: "Название модуля"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentFilters, (filter) => {
                          return _createVNode(_unref(Button), {
                            key: filter.value,
                            size: "sm",
                            variant: payFilter.value === filter.value ? 'secondary' : 'ghost',
                            "aria-pressed": payFilter.value === filter.value,
                            onClick: ($event: any) => (payFilter.value = filter.value)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(filter.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["variant", "aria-pressed", "onClick"])
                        }), 64))
                      ]),
                      _createElementVNode("label", _hoisted_20, [
                        _createVNode(_unref(Checkbox), {
                          modelValue: connectedOnly.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((connectedOnly).value = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[21] || (_cache[21] = _createElementVNode("span", null, "Только подключённые", -1))
                      ])
                    ]),
                    (!moduleSections.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(moduleSearch.value || payFilter.value !== 'all' || connectedOnly.value
                  ? 'Нет модулей по фильтру'
                  : 'Нет доступных модулей для этого продукта'), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moduleSections.value, (section) => {
                      return (_openBlock(), _createElementBlock("details", {
                        key: section.key,
                        class: "settings-module-section",
                        open: ""
                      }, [
                        _createElementVNode("summary", null, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(section.title), 1),
                          _createVNode(_unref(Badge), { variant: "outline" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(section.modules.length), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_unref(Button), {
                            size: "sm",
                            variant: "outline",
                            onClick: ($event: any) => (enableGroup(section.modules))
                          }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode(" Вкл. все ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_unref(Button), {
                            size: "sm",
                            variant: "ghost",
                            onClick: ($event: any) => (disableGroup(section.modules))
                          }, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode(" Выкл. все ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.modules, (mod) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: mod.id,
                              class: _normalizeClass(["module-item", {
                    'module-item--active': getModuleState(mod.id).active,
                    'module-item--paid': mod.is_paid,
                    'module-item--free': !mod.is_paid,
                  }])
                            }, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("label", _hoisted_26, [
                                  _createVNode(_unref(Checkbox), {
                                    "model-value": getModuleState(mod.id).active,
                                    "aria-label": mod.name,
                                    "onUpdate:modelValue": (val) => updateModuleActive(mod.id, Boolean(val), mod)
                                  }, null, 8, ["model-value", "aria-label", "onUpdate:modelValue"]),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["mark", { 'mark-paid': mod.is_paid }]),
                                    title: mod.is_paid ? 'Платный' : undefined
                                  }, [
                                    (mod.is_paid)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode("₽")
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_27),
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(mod.name), 1)
                                ]),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(getModuleState(mod.id).active && getModuleState(mod.id).price
                          ? formatMoney(getModuleState(mod.id).price)
                          : ''), 1),
                                (getModuleState(mod.id).active)
                                  ? (_openBlock(), _createBlock(_unref(Button), {
                                      key: 0,
                                      variant: "ghost",
                                      size: "icon",
                                      class: "fact-action",
                                      "aria-label": 
                        getModuleState(mod.id).notes ? 'Изменить примечание' : 'Добавить примечание'
                      ,
                                      title: 
                        getModuleState(mod.id).notes ? 'Изменить примечание' : 'Добавить примечание'
                      ,
                                      onClick: ($event: any) => (isNotesOpen(mod.id) ? closeNotes(mod.id) : openNotes(mod.id))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NotebookPen), { size: 14 })
                                      ]),
                                      _: 1
                                    }, 8, ["aria-label", "title", "onClick"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_30))
                              ]),
                              (getModuleState(mod.id).active)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    (mod.is_paid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createElementVNode("label", _hoisted_33, [
                                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "ui-label" }, "Стоимость", -1)),
                                            _createVNode(_unref(Input), {
                                              "model-value": getModuleState(mod.id).price,
                                              type: "number",
                                              step: "0.01",
                                              min: "0",
                                              "onUpdate:modelValue": 
                            (val) =>
                              updateModuleField(mod.id, 'price', String(val))
                          
                                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("label", _hoisted_34, [
                                            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "ui-label" }, "Приобретён", -1)),
                                            _createVNode(_unref(Input), {
                                              "model-value": getModuleState(mod.id).acquired_at,
                                              type: "date",
                                              "onUpdate:modelValue": 
                            (val) =>
                              updateModuleField(mod.id, 'acquired_at', String(val))
                          
                                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("label", {
                                              for: 'module-license-' + mod.id,
                                              class: "ui-label"
                                            }, " Срок действия ", 8, _hoisted_36),
                                            _createVNode(_unref(Input), {
                                              id: 'module-license-' + mod.id,
                                              "model-value": getModuleState(mod.id).license_expires,
                                              type: "date",
                                              disabled: getModuleState(mod.id).isUnlimited,
                                              "onUpdate:modelValue": 
                            (val) =>
                              updateModuleField(mod.id, 'license_expires', String(val))
                          
                                            }, null, 8, ["id", "model-value", "disabled", "onUpdate:modelValue"]),
                                            _createElementVNode("label", _hoisted_37, [
                                              _createVNode(_unref(Checkbox), {
                                                "model-value": getModuleState(mod.id).isUnlimited,
                                                "onUpdate:modelValue": (val) => updateUnlimited(mod.id, Boolean(val))
                                              }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                              _cache[26] || (_cache[26] = _createElementVNode("span", null, "Бессрочно", -1))
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (isNotesOpen(mod.id))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                          _createElementVNode("label", _hoisted_39, [
                                            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "ui-label" }, "Примечание", -1)),
                                            _createVNode(_unref(Textarea), {
                                              "model-value": getModuleState(mod.id).notes,
                                              rows: "2",
                                              "onUpdate:modelValue": 
                            (val) => updateModuleField(mod.id, 'notes', val)
                          
                                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                                          ]),
                                          _createVNode(_unref(Button), {
                                            size: "sm",
                                            variant: "ghost",
                                            class: "mt-1",
                                            onClick: ($event: any) => (closeNotes(mod.id))
                                          }, {
                                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                              _createTextVNode(" Свернуть ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
          ]),
          _createVNode(_unref(SheetFooter), { class: "settings-dialog__footer" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "outline",
                disabled: saving.value,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (drawer.value = false))
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("Отмена", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(Button), {
                disabled: loading.value || saving.value,
                onClick: save
              }, {
                default: _withCtx(() => [
                  (saving.value)
                    ? (_openBlock(), _createBlock(_unref(Spinner), { key: 0 }))
                    : _createCommentVNode("", true),
                  _cache[30] || (_cache[30] = _createTextVNode(" Сохранить ", -1))
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})